<!-- Login Form -->
<div class="min-h-screen bg-brand-200 flex items-center justify-center p-4">
  <div class="w-full max-w-md">
    <!-- Logo/Brand Section -->
    <div class="text-center mb-8">
      <div class="flex items-center justify-center mx-auto mb-4">
        <img
          [src]="environment.assetsPrefix + '/images/Final Logo No Tagline OL.png'"
          alt="AKA Logo"
          class="h-32 object-contain"
        />
      </div>
      <h1 class="text-2xl font-bold text-black font-outfit mb-2">Welcome Back</h1>
      <p class="text-gray-600 font-raleway">
        Sign in to your AKA account
      </p>
    </div>

    <!-- Login Card -->
    <div class="bg-white rounded-3xl shadow-xl p-8">
      <div>
        <form>
          <div class="space-y-6">
            <!-- Email -->
            <div>
              <label
                class="block text-sm font-medium text-black mb-2 font-raleway"
              >
                Email Address<span class="text-error-500 ml-1">*</span>
              </label>
              <input
                id="email"
                name="email"
                type="email"
                [disabled]="loggingIn"
                [(ngModel)]="credentials.email"
                placeholder="Enter your email"
                class="w-full h-12 rounded-xl border-2 border-gray-200 bg-gray-50 px-4 py-3 text-sm text-black placeholder:text-gray-500 focus:border-brand-500 focus:bg-white focus:outline-none transition-all duration-200 font-raleway"
              />
            </div>
            <!-- Password -->
            <div>
              <label
                class="block text-sm font-medium text-black mb-2 font-raleway"
              >
                Password<span class="text-error-500 ml-1">*</span>
              </label>
              <div class="relative">
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  [disabled]="loggingIn"
                  [(ngModel)]="credentials.password"
                  [ngModelOptions]="{standalone: true}"
                  placeholder="Enter your password"
                  class="w-full h-12 rounded-xl border-2 border-gray-200 bg-gray-50 px-4 py-3 pr-12 text-sm text-black placeholder:text-gray-500 focus:border-brand-500 focus:bg-white focus:outline-none transition-all duration-200 font-raleway"
                />
                <button
                  type="button"
                  class="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 transition-colors"
                  (click)="showPassword = !showPassword"
                >
                  @if (showPassword) {
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L8.464 8.464M14.12 14.12l1.414 1.414"/>
                    </svg>
                  } @else {
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                    </svg>
                  }
                </button>
                </div>
            </div>

            <!-- Remember Me & Forgot Password -->
            <div class="flex items-center justify-between">
              <label class="flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  [(ngModel)]="rememberMe"
                  [ngModelOptions]="{standalone: true}"
                  class="sr-only"
                />
                <div class="relative">
                  <div
                    [ngClass]="rememberMe ? 'bg-brand-500 border-brand-500' : 'bg-white border-gray-300'"
                    class="w-5 h-5 rounded border-2 transition-all duration-200 flex items-center justify-center"
                  >
                    <svg
                      [ngClass]="rememberMe ? 'opacity-100' : 'opacity-0'"
                      class="w-3 h-3 text-white transition-opacity duration-200"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"/>
                    </svg>
                  </div>
                </div>
                <span class="ml-3 text-sm text-gray-600 font-raleway">Remember me</span>
              </label>
              <a
                href="#"
                class="text-sm text-brand-500 hover:text-brand-600 font-raleway font-medium transition-colors"
              >
                Forgot password?
              </a>
            </div>

            <!-- Sign In Button -->
            <button
              type="button"
              [disabled]="loggingIn || !credentials.email || !credentials.password"
              (click)="login()"
              [ngClass]="{
                'bg-brand-500 hover:bg-brand-600': !loggingIn && credentials.email && credentials.password,
                'bg-gray-300 cursor-not-allowed': loggingIn || !credentials.email || !credentials.password
              }"
              class="w-full h-12 rounded-xl text-white font-medium transition-all duration-200 font-raleway flex items-center justify-center space-x-2"
            >
              @if (loggingIn) {
                <svg class="animate-spin w-5 h-5" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <span>Signing In...</span>
              } @else {
                <span>Sign In</span>
              }
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- Footer -->
    <div class="text-center mt-8">
      <p class="text-sm text-gray-500 font-raleway">
        © 2025 AKA. All rights reserved.
      </p>
    </div>
  </div>
</div>
